// src/pages/Step1.js
import React, { useState, useContext } from "react";
import Dropdown from "../components/Dropdown";
import InputField from "../components/InputField";
import ProgressButton from "../components/ProgressButton";
import { Container, Card } from "../components/Layout";
import { ToastContext } from "../contexts/ToastProvider";

function Step1({ onNext }) {
  const [ethnicity, setEthnicity] = useState("");
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const { toast } = useContext(ToastContext);
  // const [isExpanded, setIsExpanded] = useState(false);

  const handleNext = () => {
    if (!ethnicity || !weight || !height) {
      toast.error("Udfyld venligst alle felter.");
      return;
    }

    const bmi = (weight / (height / 100) ** 2).toFixed(1);
    onNext({ ethnicity, weight, height, bmi });
  };

  // const onLoadMore = () => {
  //   setIsExpanded(true)
  // }
  // const onBack = () => {
  //   setIsExpanded(false)
  // }

  return (
    <Container>
      <Card>
        {/* {isExpanded ? (
          <>
            <h1>Medicinsk vægttab</h1>
            <p>Diætisthuset tilbyder medicinsk vægttabsforløb, hvor du kan starte et medicinsk vægttab eller indgå i et kombinationsforløb med vores onlineklinik. </p>
            <p>Optimér dit vægttab og skab gode vaner tilpasset din livsstil. </p>
            <ProgressButton onClick={onBack} text="Tilbage" />
          </>
        ) : (
          <>
            <h1>Medicinsk vægttab</h1>
            <p>For blot <b>295,- hver 4. uge</b> kan du påbegynde dit medicinske vægttab hos Diætisthuset.</p>
            <p>Vi tilbyder forløb, hvor du kan starte et medicinsk vægttab eller indgå i et kombinationsforløb med vores diætister. Optimér dit vægttab og skab gode vaner tilpasset din livsstil.</p>
            <ProgressButton onClick={onLoadMore} text="Læs mere" />
          </>
        )
        } */}
        <img src="/6595321302179.svg" alt="Logo" />
        <h1>Indtast oplysninger</h1>
        <Dropdown
          label="Etnicitet"
          options={[
            "Hvid",
            "Sydasiatisk",
            "Kinesisk",
            "Mellemøstlig",
            "Sort Afrikansk",
            "Afro-Caribisk",
          ]}
          value={ethnicity}
          onChange={setEthnicity}
        />
        <InputField
          label="Vægt (kg)"
          value={weight}
          type="number"
          onChange={setWeight}
        />
        <InputField
          label="Højde (cm)"
          value={height}
          type="number"
          onChange={setHeight}
        />
        <ProgressButton text="Beregn BMI" onClick={handleNext} />
      </Card>
    </Container>
  );
}

export default Step1;
